import { useGetHistoryQuery } from '@cockpitai/integration/chat/hooks'
import { ptBR } from 'date-fns/locale'
import { useState } from 'react'

import {
  checkToday,
  checkYesterday,
} from '@cockpitai/components/helpers/calcDays'
import { routesPath } from '@cockpitai/constants/routesPath'
import { useChatStore } from '@cockpitai/store/chat'
import { useLevelNavigation } from '@cockpitai/store/navigation/useLevelNavigation'
import {
  differenceInDays,
  differenceInMonths,
  differenceInWeeks,
  format,
  parseISO,
} from 'date-fns'
import { useNavigate } from 'react-router-dom'
import { TSectionListItem } from './SectionList'

export type TSection = {
  title: string
  items: TSectionListItem[]
}

export function useHistoryChat() {
  const [search, setSearch] = useState('')

  const { resetNavigation } = useLevelNavigation()

  const { setIsStartedChat, setChatId, clearMessages } = useChatStore()

  const { data, isLoading } = useGetHistoryQuery()

  const navigate = useNavigate()

  let sections: TSection[] = []

  const today = new Date()

  const chatData = data && data.length > 0 ? [...data].reverse() : []

  chatData.forEach((item) => {
    const date = parseISO(
      item?.created_at ? item.created_at : new Date().toISOString(),
    )

    const month = format(date, 'MMMM yyyy', { locale: ptBR })

    const monthDescribe = month.at(0)?.toUpperCase() + month.slice(1)

    const section: TSection = (() => {
      if (checkToday(date)) {
        return { title: 'Hoje', items: [] }
      } else if (checkYesterday(date)) {
        return { title: 'Ontem', items: [] }
      }

      const daysDifference = differenceInDays(today, date)

      const weeksDifference = differenceInWeeks(today, date)

      const monthsDifference = differenceInMonths(today, date)

      if (daysDifference <= 6) {
        return { title: `${daysDifference + 1} dias atrás`, items: [] }
      } else if (weeksDifference === 1) {
        return { title: 'Semana passada', items: [] }
      } else if (weeksDifference <= 4) {
        return { title: `${weeksDifference} semanas atrás`, items: [] }
      } else if (monthsDifference === 1) {
        return { title: 'Mês passado', items: [] }
      } else {
        return { title: monthDescribe, items: [] }
      }
    })()

    const existingSection = sections.find((s) => s.title === section.title)

    const itemParsed = {
      id: item.chat_id,
      title: item.chat_title,
    }

    if (existingSection) {
      existingSection.items.push(itemParsed)
    } else {
      section.items.push(itemParsed)

      sections.push(section)
    }
  })

  if (search) {
    sections = sections.filter((section) => {
      const filtered = section.items.filter((item) =>
        item.title.toLowerCase().includes(search.toLowerCase()),
      )

      section.items = filtered

      return filtered.length > 0
    })
  }

  const handleSelectMessage = (historyChatId: number) => {
    clearMessages()

    setIsStartedChat(true)

    setChatId(historyChatId)

    resetNavigation()

    navigate(routesPath.dashboard.chat + '/' + historyChatId, {
      replace: true,
    })
  }

  return {
    handleSelectMessage,
    isLoading,
    sections,
    setSearch,
    searchTerm: search,
  }
}
